import React, { Fragment } from 'react';

export function FacebookVideoPreview({ src }) {
  if (!src) {
    return <Fragment />;
  }

  return <img src={src} alt="preview" style={{ objectFit: 'cover', width: '100%', height: '100px' }} />;
}
